const eInsightBaseUrl = process.env.VUE_APP_EINSIGHT_URL
const eInsightUrl = {
  create: (companyId) => eInsightBaseUrl + 'Project/Create?companyId=' + `${companyId}`,
  view: (projectId) => eInsightBaseUrl + 'Project/View?projectId=' + `${projectId}`,
  edit: (projectId) => eInsightBaseUrl + 'Project/Edit?projectId=' + `${projectId}`,
  editSchedule: (projectId) => eInsightBaseUrl + 'Project/Schedule?projectId=' + `${projectId}#schedule`,
  activateSchedule: (projectId) => eInsightBaseUrl + 'Project/EditSchedule?projectId=' + `${projectId}#schedule`,
  cancelSchedule: (projectId) => eInsightBaseUrl + 'Project/CancelSchedule?projectId=' + `${projectId}`,
  deactivateSchedule: (projectId) => eInsightBaseUrl + 'Project/CancelSchedule?projectId=' + `${projectId}`,
  approval: (projectId) => eInsightBaseUrl + 'Approval/Approve?projectId=' + `${projectId}`,
  disapproval: (projectId) => eInsightBaseUrl + 'Approval/Disapprove?projectId=' + `${projectId}`,
  clone: () => eInsightBaseUrl + 'Project/ManageCampaigns',
  requestInboxPreview: (projectId) => eInsightBaseUrl + 'RequestIP?projectId=' + `${projectId}` + '&section=ManageCampaign',
  requestInboxForecaster: (projectId) => eInsightBaseUrl + 'RequestADR?projectId=' + `${projectId}` + '&section=ManageCampaign',
  sendForApproval: (projectId, companyId) => eInsightBaseUrl + `Approval/RequestForEmailContentApproval?projectId=${projectId}&companyId=${companyId}`,
  preview: (projectId) => eInsightBaseUrl + `Template/GetProjectTemplateContent?projectId=${projectId}`
}

export default eInsightUrl
